import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-image-multiple"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasHover)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", _mergeProps({
          src: _ctx.imageSrc,
          class: ["base-image", _ctx.additionalClasses]
        }, { alt: _ctx.alt, ..._ctx.responsiveImage }), null, 16, _hoisted_2),
        _createElementVNode("img", _mergeProps({
          src: _ctx.hoverImageSrc ?? '',
          class: ["base-image base-image--hover", _ctx.additionalClasses]
        }, { alt: _ctx.alt, ..._ctx.hoverResponsiveImage }), null, 16, _hoisted_3)
      ]))
    : (_openBlock(), _createElementBlock("img", _mergeProps({
        key: 1,
        src: _ctx.imageSrc,
        class: ["base-image", _ctx.additionalClasses]
      }, { alt: _ctx.alt, ..._ctx.responsiveImage }), null, 16, _hoisted_4))
}